module.exports = __webpack_public_path__ + "static/img/10.32761b6d.png";